var $b78a78aa1e5e340c$exports = {};
$b78a78aa1e5e340c$exports = import.meta.resolve("biQUI");


var $0348158c6433c823$exports = {};
$0348158c6433c823$exports = import.meta.resolve("loJgB");


var $4394e0cd87908de3$exports = {};
$4394e0cd87908de3$exports = import.meta.resolve("7DKK0");


var $ce7ebacbbfe9ed2a$exports = {};
$ce7ebacbbfe9ed2a$exports = import.meta.resolve("aK7Bc");


var $d0d79cfb8f13eab8$exports = {};
$d0d79cfb8f13eab8$exports = import.meta.resolve("kPzpT");


var $63993e39a0a17dd8$exports = {};
$63993e39a0a17dd8$exports = import.meta.resolve("1YBhO");


var $1c80c01a484c0b3b$exports = {};
$1c80c01a484c0b3b$exports = import.meta.resolve("79qkz");


var $6adf48a91c853f05$exports = {};
$6adf48a91c853f05$exports = import.meta.resolve("2q731");


var $822421dbda169e97$exports = {};
$822421dbda169e97$exports = import.meta.resolve("6STeW");


var $1267c398c6770d13$exports = {};
$1267c398c6770d13$exports = import.meta.resolve("G5B2e");


var $7972c42486201be2$exports = {};
$7972c42486201be2$exports = import.meta.resolve("kRHJZ");


var $d4f7404ef1486f68$exports = {};
$d4f7404ef1486f68$exports = import.meta.resolve("6pKAu");


var $bd464f9670d2da06$exports = {};
$bd464f9670d2da06$exports = import.meta.resolve("8Elz3");


var $0dd1d346b75e5933$exports = {};
$0dd1d346b75e5933$exports = import.meta.resolve("hTDHX");


var $6a5e9d8becff0393$exports = {};
$6a5e9d8becff0393$exports = import.meta.resolve("lkQXf");


var $562f928987e517b1$exports = {};
$562f928987e517b1$exports = import.meta.resolve("66dkk");


var $28184b213b1a3725$exports = {};
$28184b213b1a3725$exports = import.meta.resolve("7NgJM");


var $6e57fde722874729$exports = {};
$6e57fde722874729$exports = import.meta.resolve("3ScIh");


var $cb15c3b609ef3f70$exports = {};
$cb15c3b609ef3f70$exports = import.meta.resolve("8Yy4N");


var $560167116f40af14$exports = {};
$560167116f40af14$exports = import.meta.resolve("7ppGK");


var $70b1325c113a367a$exports = {};
$70b1325c113a367a$exports = import.meta.resolve("bkWNX");


var $6c3a4cccca984943$exports = {};
$6c3a4cccca984943$exports = import.meta.resolve("7sn2m");


var $8a2bc5929220afa0$exports = {};
$8a2bc5929220afa0$exports = import.meta.resolve("g5ldh");


var $2473187802bf181e$exports = {};
$2473187802bf181e$exports = import.meta.resolve("fxojF");


var $7c190661c2a0c03a$exports = {};
$7c190661c2a0c03a$exports = import.meta.resolve("dGbPF");


var $cc9d5d85e01c95b1$exports = {};
$cc9d5d85e01c95b1$exports = import.meta.resolve("88Sh4");


var $a8dbe6512c12fb41$exports = {};
$a8dbe6512c12fb41$exports = import.meta.resolve("bTMZL");


var $7255be665303463d$exports = {};
$7255be665303463d$exports = import.meta.resolve("drlSh");


var $61b9439ff2bad7c2$exports = {};
$61b9439ff2bad7c2$exports = import.meta.resolve("6VLXs");


var $83ce45bec5a96aef$exports = {};
$83ce45bec5a96aef$exports = import.meta.resolve("25VPQ");


var $0df1b95b0f48c0eb$exports = {};
$0df1b95b0f48c0eb$exports = import.meta.resolve("gxFWy");


var $3d7064d705b7ba1d$exports = {};
$3d7064d705b7ba1d$exports = import.meta.resolve("3a7qX");


var $0a2c9b7bd16d51f8$exports = {};
$0a2c9b7bd16d51f8$exports = import.meta.resolve("k8ZjY");


var $0a303b8e609223f7$exports = {};
$0a303b8e609223f7$exports = import.meta.resolve("aldNR");


var $29001f53068baefc$exports = {};
$29001f53068baefc$exports = import.meta.resolve("hhVbX");


var $73f91b6cbb47338e$exports = {};
$73f91b6cbb47338e$exports = import.meta.resolve("gUc8E");


var $780e259280fdf45c$exports = {};
$780e259280fdf45c$exports = import.meta.resolve("ay4Qe");


var $4923cda763d4103c$exports = {};
$4923cda763d4103c$exports = import.meta.resolve("d8Lop");


var $6f1258dea2ad1dad$exports = {};
$6f1258dea2ad1dad$exports = import.meta.resolve("kFFaT");


var $e02f7e5729489f55$exports = {};
$e02f7e5729489f55$exports = import.meta.resolve("dcxdY");


var $56fb525b77003b6b$exports = {};
$56fb525b77003b6b$exports = import.meta.resolve("5My1I");


var $d963c38d8b596a0c$exports = {};
$d963c38d8b596a0c$exports = import.meta.resolve("8UqOl");


var $8df0d67834ecdca2$exports = {};
$8df0d67834ecdca2$exports = import.meta.resolve("hov8Z");


var $2eed41ee851906e1$exports = {};
$2eed41ee851906e1$exports = import.meta.resolve("3Z4Na");


var $b1ecd12aab56ed9a$exports = {};
$b1ecd12aab56ed9a$exports = import.meta.resolve("bxDtr");


var $1442e95f20b92709$exports = {};
$1442e95f20b92709$exports = import.meta.resolve("2QwHl");


var $d49449549d54026a$exports = {};
$d49449549d54026a$exports = import.meta.resolve("lYmGv");


var $736e77a546f19764$exports = {};
$736e77a546f19764$exports = import.meta.resolve("iXkdy");


var $891a8f4227b68b4e$exports = {};
$891a8f4227b68b4e$exports = import.meta.resolve("MBD6i");


var $6b06a8dcc9f18f78$exports = {};
$6b06a8dcc9f18f78$exports = import.meta.resolve("gOlLZ");


var $033bea49365c44a9$exports = {};
$033bea49365c44a9$exports = import.meta.resolve("bRvxA");


var $59c6d8aa8c2460b6$exports = {};
$59c6d8aa8c2460b6$exports = import.meta.resolve("aljHO");


var $f5924220d71297d8$exports = {};
$f5924220d71297d8$exports = import.meta.resolve("MGUwg");


var $18e70a35bdbd40d8$exports = {};
$18e70a35bdbd40d8$exports = import.meta.resolve("jePft");


var $fe2870026edf3d8f$exports = {};
$fe2870026edf3d8f$exports = import.meta.resolve("fLOO4");


var $6d4551e71c9174d0$exports = {};
$6d4551e71c9174d0$exports = import.meta.resolve("9kgo3");


var $c552b44489cc053e$exports = {};
$c552b44489cc053e$exports = import.meta.resolve("cLLXT");


var $66b1218210f08538$exports = {};
$66b1218210f08538$exports = import.meta.resolve("3JQrj");


var $be11bae87b5f6ebd$exports = {};
$be11bae87b5f6ebd$exports = import.meta.resolve("iGcqC");


var $ffef647b0ed0f1f6$exports = {};
$ffef647b0ed0f1f6$exports = import.meta.resolve("k5UKs");


var $35a90f9b70686917$exports = {};
$35a90f9b70686917$exports = import.meta.resolve("iRG0B");


var $994135410fd43a6a$exports = {};
$994135410fd43a6a$exports = import.meta.resolve("lRz8C");


var $7b1d3f3308ed4acc$exports = {};
$7b1d3f3308ed4acc$exports = import.meta.resolve("fs67R");


var $935b45c21ac067fc$exports = {};
$935b45c21ac067fc$exports = import.meta.resolve("5Ggn9");


var $cba383674f083d2a$exports = {};
$cba383674f083d2a$exports = import.meta.resolve("dtU6b");


var $2320986450d5cde5$exports = {};
$2320986450d5cde5$exports = import.meta.resolve("kPd8l");


var $2973e526fc9e57f6$exports = {};
$2973e526fc9e57f6$exports = import.meta.resolve("7HaUw");


var $f24be2c708d031f1$exports = {};
$f24be2c708d031f1$exports = import.meta.resolve("4Psuy");


var $d1c9953ba8396c20$exports = {};
$d1c9953ba8396c20$exports = import.meta.resolve("iLPPK");


var $0dcd997f1d6e96d0$exports = {};
$0dcd997f1d6e96d0$exports = import.meta.resolve("8iL6t");


var $d3b3bc2aff02fda8$exports = {};
$d3b3bc2aff02fda8$exports = import.meta.resolve("idqx4");


var $bdaa6b54f4f039aa$exports = {};
$bdaa6b54f4f039aa$exports = import.meta.resolve("iXZNW");


var $47d12039369b3671$exports = {};
$47d12039369b3671$exports = import.meta.resolve("hx8NA");


var $c620fd3e5fb2a6c4$exports = {};
$c620fd3e5fb2a6c4$exports = import.meta.resolve("3UMGb");


var $1c3ec82e8f3d9598$exports = {};
$1c3ec82e8f3d9598$exports = import.meta.resolve("4JawA");


var $e79d2e960522e7a0$exports = {};
$e79d2e960522e7a0$exports = import.meta.resolve("4W79F");


var $9922bda6143fcee3$exports = {};
$9922bda6143fcee3$exports = import.meta.resolve("8ohqi");


var $2fb0fe1a4fcad9b9$exports = {};
$2fb0fe1a4fcad9b9$exports = import.meta.resolve("iW8Sd");


var $bb75d72bde76a1db$exports = {};
$bb75d72bde76a1db$exports = import.meta.resolve("gDjWY");


var $59c322fc8c4dd61a$exports = {};
$59c322fc8c4dd61a$exports = import.meta.resolve("h7q0H");


var $695f9b7d393ac3b8$exports = {};
$695f9b7d393ac3b8$exports = import.meta.resolve("ezXA1");


var $6a763287f2265e9b$exports = {};
$6a763287f2265e9b$exports = import.meta.resolve("ewL7u");


var $2dadc13d0539d89c$exports = {};
$2dadc13d0539d89c$exports = import.meta.resolve("hkX48");


var $f461fdd315e2e727$exports = {};
$f461fdd315e2e727$exports = import.meta.resolve("30liz");


var $06becf2505bc6071$exports = {};
$06becf2505bc6071$exports = import.meta.resolve("9i4zX");


var $3496cf798eb8bf4c$exports = {};
$3496cf798eb8bf4c$exports = import.meta.resolve("cRc4w");


const $e72d86e36296230f$var$AUDIO_FILES = {
    1: new URL($b78a78aa1e5e340c$exports).toString(),
    2: new URL($0348158c6433c823$exports).toString(),
    3: new URL($4394e0cd87908de3$exports).toString(),
    4: new URL($ce7ebacbbfe9ed2a$exports).toString(),
    5: new URL($d0d79cfb8f13eab8$exports).toString(),
    6: new URL($63993e39a0a17dd8$exports).toString(),
    7: new URL($1c80c01a484c0b3b$exports).toString(),
    8: new URL($6adf48a91c853f05$exports).toString(),
    9: new URL($822421dbda169e97$exports).toString(),
    10: new URL($1267c398c6770d13$exports).toString(),
    11: new URL($7972c42486201be2$exports).toString(),
    12: new URL($d4f7404ef1486f68$exports).toString(),
    13: new URL($bd464f9670d2da06$exports).toString(),
    14: new URL($0dd1d346b75e5933$exports).toString(),
    15: new URL($6a5e9d8becff0393$exports).toString(),
    16: new URL($562f928987e517b1$exports).toString(),
    17: new URL($28184b213b1a3725$exports).toString(),
    18: new URL($6e57fde722874729$exports).toString(),
    19: new URL($cb15c3b609ef3f70$exports).toString(),
    20: new URL($560167116f40af14$exports).toString(),
    21: new URL($70b1325c113a367a$exports).toString(),
    22: new URL($6c3a4cccca984943$exports).toString(),
    23: new URL($8a2bc5929220afa0$exports).toString(),
    24: new URL($2473187802bf181e$exports).toString(),
    25: new URL($7c190661c2a0c03a$exports).toString(),
    26: new URL($cc9d5d85e01c95b1$exports).toString(),
    27: new URL($a8dbe6512c12fb41$exports).toString(),
    28: new URL($7255be665303463d$exports).toString(),
    29: new URL($61b9439ff2bad7c2$exports).toString(),
    30: new URL($83ce45bec5a96aef$exports).toString(),
    31: new URL($0df1b95b0f48c0eb$exports).toString(),
    32: new URL($3d7064d705b7ba1d$exports).toString(),
    33: new URL($0a2c9b7bd16d51f8$exports).toString(),
    34: new URL($0a303b8e609223f7$exports).toString(),
    35: new URL($29001f53068baefc$exports).toString(),
    36: new URL($73f91b6cbb47338e$exports).toString(),
    37: new URL($780e259280fdf45c$exports).toString(),
    38: new URL($4923cda763d4103c$exports).toString(),
    39: new URL($6f1258dea2ad1dad$exports).toString(),
    40: new URL($e02f7e5729489f55$exports).toString(),
    41: new URL($56fb525b77003b6b$exports).toString(),
    42: new URL($d963c38d8b596a0c$exports).toString(),
    43: new URL($8df0d67834ecdca2$exports).toString(),
    44: new URL($2eed41ee851906e1$exports).toString(),
    45: new URL($b1ecd12aab56ed9a$exports).toString(),
    46: new URL($1442e95f20b92709$exports).toString(),
    47: new URL($d49449549d54026a$exports).toString(),
    48: new URL($736e77a546f19764$exports).toString(),
    49: new URL($891a8f4227b68b4e$exports).toString(),
    50: new URL($6b06a8dcc9f18f78$exports).toString(),
    51: new URL($033bea49365c44a9$exports).toString(),
    52: new URL($59c6d8aa8c2460b6$exports).toString(),
    53: new URL($f5924220d71297d8$exports).toString(),
    54: new URL($18e70a35bdbd40d8$exports).toString(),
    55: new URL($fe2870026edf3d8f$exports).toString(),
    56: new URL($6d4551e71c9174d0$exports).toString(),
    57: new URL($c552b44489cc053e$exports).toString(),
    58: new URL($66b1218210f08538$exports).toString(),
    59: new URL($be11bae87b5f6ebd$exports).toString(),
    60: new URL($ffef647b0ed0f1f6$exports).toString(),
    61: new URL($35a90f9b70686917$exports).toString(),
    62: new URL($994135410fd43a6a$exports).toString(),
    63: new URL($7b1d3f3308ed4acc$exports).toString(),
    64: new URL($935b45c21ac067fc$exports).toString(),
    65: new URL($cba383674f083d2a$exports).toString(),
    66: new URL($2320986450d5cde5$exports).toString(),
    67: new URL($2973e526fc9e57f6$exports).toString(),
    68: new URL($f24be2c708d031f1$exports).toString(),
    69: new URL($d1c9953ba8396c20$exports).toString(),
    70: new URL($0dcd997f1d6e96d0$exports).toString(),
    71: new URL($d3b3bc2aff02fda8$exports).toString(),
    72: new URL($bdaa6b54f4f039aa$exports).toString(),
    73: new URL($47d12039369b3671$exports).toString(),
    74: new URL($c620fd3e5fb2a6c4$exports).toString(),
    75: new URL($1c3ec82e8f3d9598$exports).toString(),
    76: new URL($e79d2e960522e7a0$exports).toString(),
    77: new URL($9922bda6143fcee3$exports).toString(),
    78: new URL($2fb0fe1a4fcad9b9$exports).toString(),
    79: new URL($bb75d72bde76a1db$exports).toString(),
    80: new URL($59c322fc8c4dd61a$exports).toString(),
    81: new URL($695f9b7d393ac3b8$exports).toString(),
    82: new URL($6a763287f2265e9b$exports).toString(),
    83: new URL($2dadc13d0539d89c$exports).toString(),
    84: new URL($f461fdd315e2e727$exports).toString(),
    85: new URL($06becf2505bc6071$exports).toString(),
    86: new URL($3496cf798eb8bf4c$exports).toString()
};
const $e72d86e36296230f$var$form = document.getElementById("fortuneForm");
const $e72d86e36296230f$var$dobInput = document.getElementById("dob");
const $e72d86e36296230f$var$sphere = document.getElementById("sphere");
const $e72d86e36296230f$var$mist = document.getElementById("mist");
const $e72d86e36296230f$var$fortuneEl = document.getElementById("fortune");
// Audio setup
const $e72d86e36296230f$var$audioPlayer = new Audio();
var $0aaead52ecef0fcb$exports = {};
$0aaead52ecef0fcb$exports = import.meta.resolve("hY5Hn");


const $e72d86e36296230f$var$bgMusic = new Audio(new URL($0aaead52ecef0fcb$exports).toString());
$e72d86e36296230f$var$bgMusic.loop = true;
let $e72d86e36296230f$var$bgMusicTimeout = null;
let $e72d86e36296230f$var$bgMusicFadeInterval = null;
const $e72d86e36296230f$var$INITIAL_BG_VOLUME = 0.25;
function $e72d86e36296230f$var$startBgMusic() {
    clearTimeout($e72d86e36296230f$var$bgMusicTimeout);
    clearInterval($e72d86e36296230f$var$bgMusicFadeInterval);
    $e72d86e36296230f$var$bgMusic.volume = $e72d86e36296230f$var$INITIAL_BG_VOLUME;
    $e72d86e36296230f$var$bgMusic.play().catch((e)=>console.warn("Background music play blocked by browser", e));
}
function $e72d86e36296230f$var$stopBgMusicWith5SecDelay() {
    clearTimeout($e72d86e36296230f$var$bgMusicTimeout);
    clearInterval($e72d86e36296230f$var$bgMusicFadeInterval);
    const fadeDuration = 5000; // 5 seconds fade out
    const startVolume = $e72d86e36296230f$var$bgMusic.volume;
    const steps = 50;
    const stepTime = fadeDuration / steps;
    const volumeStep = startVolume / steps;
    $e72d86e36296230f$var$bgMusicFadeInterval = setInterval(()=>{
        if ($e72d86e36296230f$var$bgMusic.volume - volumeStep > 0) $e72d86e36296230f$var$bgMusic.volume -= volumeStep;
        else {
            $e72d86e36296230f$var$bgMusic.volume = 0;
            $e72d86e36296230f$var$bgMusic.pause();
            $e72d86e36296230f$var$bgMusic.currentTime = 0;
            clearInterval($e72d86e36296230f$var$bgMusicFadeInterval);
        }
    }, stepTime);
}
// Don't allow future dates
$e72d86e36296230f$var$dobInput.max = new Date().toISOString().split("T")[0];
const $e72d86e36296230f$var$CATEGORIES = {
    "opening": [
        "The stars reveal that",
        "The ancient spirits whisper that",
        "Your destiny suggests that",
        "The cosmic forces indicate that",
        "I sense that",
        "The crystal ball has revealed that",
        "The universe has decided that",
        "A mysterious voice tells me that",
        "The alignment of the planets suggests that",
        "The tea leaves insist that",
        "The squirrel of doom predicts that",
        "A discarded piece of chewing gum that has been trodden on every day for most of its life wants to tell you that",
        "By the power of Leighton the Buzzard has decreed that",
        "Denise and Da Nephew prophesise that",
        "Pew, Pew, Barney, McGrew, Cuthbert, Dibble and Grub have decided that",
        "A bubble in the bath told me that",
        "The freckles on my bottom say that"
    ],
    "subject": [
        "a surprisingly confident pigeon",
        "your left sock",
        "a mysterious stranger",
        "an unusually large duck",
        "your neighbour's cat",
        "a suspiciously shiny potato",
        "a forgotten sandwich",
        "a person carrying three umbrellas",
        "a very judgemental squirrel",
        "a rogue garden gnome",
        "an emotionally complicated seagull",
        "a small but determined penguin",
        "your kettle",
        "a man called Dave",
        "a mysterious wheelie bin",
        "the eels in the hovercraft",
        "a bit of purple fluff, nestled in your belly botton"
    ],
    "action": [
        "will change your life",
        "will bring you unexpected fortune",
        "will demand an explanation",
        "will reveal a secret you already knew",
        "will become strangely important",
        "will lead you into an adventure",
        "will offer you an opportunity you probably shouldn't take",
        "will turn up exactly when you need it",
        "will challenge your understanding of reality",
        "will somehow become your responsibility",
        "will ask you a deeply philosophical question",
        "will cause mild confusion",
        "will become involved in your finances",
        "will appear in a place where it definitely shouldn't be",
        "will give you a chance to win an illudium Q-36 explosive sound modulator",
        "will force you to eat 5 globs of semi fossilised cro-magnon toe jam",
        "will forbid you talk to Bill the Bongo Bubble Master"
    ],
    "time": [
        "before Thursday",
        "within seven days",
        "after lunch",
        "when the moon is full",
        "sometime next week",
        "at exactly 3:17pm",
        "before the end of the month",
        "when you least expect it",
        "during your next cup of tea",
        "on a day ending in 'y'",
        "before you find your keys",
        "very, very soon",
        "the day after you meet a man called Dave",
        "at the next full moon",
        "when a crow sings 'Rule Britannia' while perched on the roof of the town hall",
        "when you find soggy vegetables in the compartment at the bottom of the fridge",
        "when Beetlejuice is in Uranus"
    ],
    "advice": [
        "Do not ignore the signs.",
        "Trust your instincts. Unless they involve pigeons.",
        "Proceed with caution and bring snacks.",
        "Ask questions, but not too many.",
        "Keep an open mind and a closed fridge.",
        "You already know what you must do.",
        "Do not make eye contact with the duck.",
        "Take the opportunity. It may not come with instructions.",
        "Remember: fortune favours the unnecessarily prepared.",
        "The universe is not responsible for what happens next.",
        "Wear sensible shoes.",
        "Most importantly, don't mention the cheese.",
        "Please slide to the right, slide to the left and quickstep real fast.",
        "Whatever you do, don't think about penguins",
        "Take the path less trodden. We need the grass to grow back.",
        "Dance like no one is watching you",
        "Stay Dry! You will only ever get eaten by a shark if you get wet."
    ]
};
function $e72d86e36296230f$var$seededRandom(seed) {
    let a = seed >>> 0;
    return function() {
        a |= 0;
        a = a + 0x6d2b79f5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function $e72d86e36296230f$var$hashDate(dateStr) {
    const digits = dateStr.replace(/-/g, "").split("").map(Number);
    return digits.reduce((acc, d)=>acc * 31 + d, 7) >>> 0;
}
function $e72d86e36296230f$var$readFortune(dateStr) {
    const rand = $e72d86e36296230f$var$seededRandom($e72d86e36296230f$var$hashDate(dateStr));
    const pickWithAudio = (arr, offset)=>{
        const idx = Math.floor(rand() * arr.length);
        const fileNum = offset + idx + 1;
        return {
            text: arr[idx],
            audio: $e72d86e36296230f$var$AUDIO_FILES[fileNum]
        };
    };
    return {
        opening: pickWithAudio($e72d86e36296230f$var$CATEGORIES.opening, 0),
        subject: pickWithAudio($e72d86e36296230f$var$CATEGORIES.subject, 17),
        action: pickWithAudio($e72d86e36296230f$var$CATEGORIES.action, 34),
        time: pickWithAudio($e72d86e36296230f$var$CATEGORIES.time, 51),
        advice: pickWithAudio($e72d86e36296230f$var$CATEGORIES.advice, 68)
    };
}
function $e72d86e36296230f$var$reveal(fortune) {
    $e72d86e36296230f$var$fortuneEl.textContent = "";
    $e72d86e36296230f$var$sphere.classList.remove("revealed");
    $e72d86e36296230f$var$mist.classList.remove("swirl");
    $e72d86e36296230f$var$sphere.offsetWidth;
    $e72d86e36296230f$var$sphere.classList.add("revealed");
    $e72d86e36296230f$var$mist.classList.add("swirl");
    $e72d86e36296230f$var$startBgMusic();
    const lines = [
        fortune.opening,
        fortune.subject,
        fortune.action,
        fortune.time,
        fortune.advice
    ];
    const playlist = lines.map((item)=>item.audio);
    let currentAudioIndex = 0;
    $e72d86e36296230f$var$audioPlayer.pause();
    function playNextAudio() {
        if (currentAudioIndex < playlist.length) {
            $e72d86e36296230f$var$audioPlayer.src = playlist[currentAudioIndex];
            currentAudioIndex++;
            $e72d86e36296230f$var$audioPlayer.play().catch((e)=>console.warn("Voice audio play blocked", e));
        } else $e72d86e36296230f$var$stopBgMusicWith5SecDelay();
    }
    $e72d86e36296230f$var$audioPlayer.onended = playNextAudio;
    playNextAudio();
    lines.forEach((item, i)=>{
        setTimeout(()=>{
            const p = document.createElement("p");
            p.className = "line";
            const strong = document.createElement("strong");
            strong.textContent = " ";
            p.appendChild(strong);
            p.appendChild(document.createTextNode(item.text));
            $e72d86e36296230f$var$fortuneEl.appendChild(p);
            $e72d86e36296230f$var$fortuneEl.scrollTop = $e72d86e36296230f$var$fortuneEl.scrollHeight;
        }, 900 + i * 1100);
    });
}
$e72d86e36296230f$var$form.addEventListener("submit", (e)=>{
    e.preventDefault();
    const dob = $e72d86e36296230f$var$dobInput.value;
    if (!dob) return;
    $e72d86e36296230f$var$reveal($e72d86e36296230f$var$readFortune(dob));
});
function $e72d86e36296230f$var$createStars() {
    const container = document.querySelector(".stars");
    const count = 140;
    for(let i = 0; i < count; i++){
        const star = document.createElement("span");
        star.className = "star";
        star.style.left = Math.random() * 100 + "%";
        star.style.top = Math.random() * 100 + "%";
        const size = Math.random() * 2 + 1;
        star.style.width = size + "px";
        star.style.height = size + "px";
        star.style.animationDelay = Math.random() * 4 + "s";
        star.style.animationDuration = Math.random() * 3 + 2 + "s";
        container.appendChild(star);
    }
}
$e72d86e36296230f$var$createStars();


//# sourceMappingURL=uncertainfuture.1974f178.js.map
